import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-change-password',
  templateUrl: './modal-change-password.component.html',
  styleUrls: ['./modal-change-password.component.scss']
})
export class ModalChangePasswordComponent implements OnInit {
  title: string;
  isShowFooter: boolean;
  data: any;
  constructor() { }

  ngOnInit() {
  }

}
